import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icons/abc.png'
import _imports_1 from '@/assets/images/icons/light.png'
import _imports_2 from '@/assets/images/icons/goal-arrow.png'
import _imports_3 from '@/assets/images/illustrations/not_found.png'


const _withScopeId = n => (_pushScopeId("data-v-02922121"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-4" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "6",
  height: "10",
  viewBox: "0 0 6 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "mr-2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 9L5 5L1 1",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_4 = { class: "relative mt-12" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "absolute inset-0 flex items-center",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-full border-t border-neutral-300" })
], -1))
const _hoisted_6 = { class: "relative flex items-center justify-between mb-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pr-3 bg-body text-lg font-semibold text-neutral-600" }, " Bước 3: Kế hoạch tiếp theo ", -1))
const _hoisted_8 = ["disabled"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "6",
  height: "10",
  viewBox: "0 0 6 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "mr-2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 9L5 5L1 1",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_10 = {
  key: 0,
  class: "bg-white shadow-sm rounded-2xl overflow-hidden my-10"
}
const _hoisted_11 = { class: "p-6" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-neutral-600" }, " Kế hoạch tiếp theo ", -1))
const _hoisted_13 = { class: "font-semibold text-green-500 capitalize mt-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-500 mt-3" }, [
  /*#__PURE__*/_createElementVNode("p", null, " Kế hoạch này sẽ được thiết lập dựa trên Báo cáo tháng bạn vừa thực hiện. Bạn có thể chỉnh sửa và thêm mục tiêu vào kế hoạch này trong mục Kế hoạch. ")
], -1))
const _hoisted_15 = { class: "p-6 border-t border-orange-50 md-down:px-0 overflow-x-auto" }
const _hoisted_16 = { class: "md-down:px-6" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-neutral-600" }, " Ngày dự kiến áp dụng Kế hoạch ", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-500 mt-3" }, [
  /*#__PURE__*/_createElementVNode("p", null, " Ngày áp dụng là ngày bạn sẽ bắt đầu dạy các mục tiêu trong kế hoạch này. ")
], -1))
const _hoisted_19 = { class: "mt-6" }
const _hoisted_20 = { class: "flex items-center" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-green-500" }, "Kế hoạch hiện tại", -1))
const _hoisted_22 = { class: "flex items-center mt-6" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-green-500" }, "Kế hoạch dự kiến", -1))
const _hoisted_24 = { class: "mt-10" }
const _hoisted_25 = {
  key: 0,
  class: "w-full"
}
const _hoisted_26 = { class: "input-group flex items-center" }
const _hoisted_27 = {
  key: 1,
  class: "w-full"
}
const _hoisted_28 = { class: "input-group items-center" }
const _hoisted_29 = { class: "p-6 border-t flex justify-end border-orange-50 overflow-x-auto" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = {
  key: 1,
  class: "bg-white shadow-sm rounded-2xl overflow-hidden my-10"
}
const _hoisted_32 = { class: "flex items-center justify-between p-6" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-neutral-600" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Kế hoạch tiếp theo")
], -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M13.6303 5.68775L15.8833 3.43471C16.7491 2.56893 17.182 2.13604 17.689 1.99526C18.0391 1.89806 18.4091 1.89806 18.7591 1.99526C19.2662 2.13604 19.6991 2.56893 20.5649 3.43471C21.4306 4.3005 21.8635 4.73339 22.0043 5.24044C22.1015 5.59052 22.1015 5.96046 22.0043 6.31054C21.8635 6.8176 21.4306 7.25049 20.5649 8.11627L18.338 10.3432C16.3854 9.2234 14.7646 7.61489 13.6303 5.68775ZM12.1759 7.14212L3.86541 15.4526C3.44035 15.8777 3.22782 16.0902 3.08808 16.3513C2.94835 16.6124 2.8894 16.9071 2.77151 17.4966L1.98573 21.4255C1.9192 21.7581 1.88594 21.9244 1.98055 22.019C2.07516 22.1136 2.24145 22.0804 2.57404 22.0139L2.57406 22.0139L2.57408 22.0138L6.503 21.2281L6.50302 21.2281C7.09246 21.1102 7.38718 21.0512 7.64828 20.9115C7.90937 20.7718 8.1219 20.5592 8.54695 20.1342L8.54696 20.1342L16.8798 11.8013C14.9781 10.6172 13.3718 9.02191 12.1759 7.14212Z",
  fill: "currentColor"
}, null, -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = { class: "p-6 border-t border-orange-50 overflow-x-auto" }
const _hoisted_37 = { class: "flex items-center md-down:flex-col md-down:items-start" }
const _hoisted_38 = { class: "w-56 text-neutral-500" }
const _hoisted_39 = { class: "font-semibold text-green-500 capitalize md-down:mt-2" }
const _hoisted_40 = { class: "flex items-center mt-8 md-down:flex-col md-down:items-start md-down:mt-4" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-56 text-neutral-500" }, "Ngày áp dụng", -1))
const _hoisted_42 = {
  key: 0,
  class: "font-semibold"
}
const _hoisted_43 = {
  key: 1,
  class: "font-semibold md-down:mt-2"
}
const _hoisted_44 = /*#__PURE__*/_createStaticVNode("<div class=\"relative\" data-v-02922121><div class=\"absolute inset-0 flex items-center\" aria-hidden=\"true\" data-v-02922121><div class=\"w-full border-t border-neutral-300\" data-v-02922121></div></div><div class=\"relative flex justify-center\" data-v-02922121><div class=\"px-2.5 py-1 bg-body text-neutral-600 font-semibold pb-2.5\" data-v-02922121> Xem trước Kế hoạch tiếp theo </div></div></div>", 1)
const _hoisted_45 = { class: "mt-10" }
const _hoisted_46 = { class: "p-6 bg-white shadow-sm rounded-2xl mb-10" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-between mb-8" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-neutral-600" }, " Thống kê chung ")
  ])
], -1))
const _hoisted_48 = { class: "flex flex-nowrap w-full md-down:flex-col" }
const _hoisted_49 = { class: "p-6 border rounded-l-lg border-neutral-200 w-full md:border-r-0 md-down:border-b-0 md-down:rounded-t md-down:rounded-b-none" }
const _hoisted_50 = { class: "text-33 font-bold text-neutral-600 mb-6 flex flex-nowrap items-center" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  width: "32",
  height: "32",
  class: "mr-2",
  style: {"height":"32px"}
}, null, -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-500 text-sm" }, "Tổng số lĩnh vực ")
], -1))
const _hoisted_53 = { class: "p-6 border border-r-0 border-neutral-200 w-full md-down:border-r md-down:border-b-0" }
const _hoisted_54 = { class: "text-33 font-bold text-neutral-600 mb-6 flex flex-nowrap items-center" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  width: "32",
  height: "32",
  class: "mr-2",
  style: {"height":"32px"}
}, null, -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-500 text-sm" }, "Tổng số mục tiêu")
], -1))
const _hoisted_57 = { class: "p-6 border rounded-r-lg border-neutral-200 w-full md-down:rounded-b md-down:rounded-t-none" }
const _hoisted_58 = { class: "text-33 font-bold text-neutral-600 mb-6 flex flex-nowrap items-center" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  width: "32",
  height: "32",
  class: "mr-2",
  style: {"height":"32px"}
}, null, -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-500 text-sm" }, "Mục tiêu học lại")
], -1))
const _hoisted_61 = { key: 0 }
const _hoisted_62 = { class: "font-semibold text-lg text-neutral-600 mb-4" }
const _hoisted_63 = { class: "shadow-sm sm:rounded-2xl overflow-hidden" }
const _hoisted_64 = { class: "__record__table overflow-x-auto scroll-bar" }
const _hoisted_65 = { class: "overflow-hidden sm:rounded-t-2xl w-fit min-w-full" }
const _hoisted_66 = { class: "min-w-full divide-y text-neutral-200" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "bg-neutral-100 h-16" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider w-16 whitespace-nowrap"
    }, " STT "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap",
      style: {"min-width":"160px"}
    }, " Nội dung ")
  ])
], -1))
const _hoisted_68 = { class: "px-6 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_69 = { class: "ml-2" }
const _hoisted_70 = { class: "px-6 py-4 text-neutral-700" }
const _hoisted_71 = ["innerHTML"]
const _hoisted_72 = {
  key: 0,
  class: "flex gap-2 flex-wrap",
  style: {"max-width":"360px"}
}
const _hoisted_73 = {
  key: 0,
  class: "mt-1 py-0.5 px-2.5 rounded-full bg-neutral-200 text-neutral-700 h-fit w-fit font-semibold shadow-input whitespace-nowrap",
  style: {"font-size":"10px"}
}
const _hoisted_74 = {
  class: "mt-1 py-0.5 px-2.5 rounded-full bg-pink-100 whitespace-nowrap text-neutral-700 h-fit w-fit font-semibold shadow-input",
  style: {"font-size":"10px"}
}
const _hoisted_75 = {
  key: 2,
  class: "mt-1 py-0.5 px-2.5 rounded-full bg-yellow-tag text-neutral-700 h-fit w-fit font-semibold shadow-input whitespace-nowrap",
  style: {"font-size":"10px"}
}
const _hoisted_76 = {
  key: 1,
  class: "goal-block flex gap-3 mt-2"
}
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-3 h-3 mt-1",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_78 = { class: "text-neutral-700" }
const _hoisted_79 = { class: "text-neutral-400 text-xs font-semibold" }
const _hoisted_80 = {
  key: 1,
  class: "w-full h-full flex items-center justify-center flex-col"
}
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "",
  height: "250",
  width: "250"
}, null, -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-600 text-center text-lg" }, " Chưa có mục tiêu dự kiến ", -1))
const _hoisted_83 = [
  _hoisted_81,
  _hoisted_82
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DaIcon = _resolveComponent("DaIcon")!
  const _component_VueDatepicker = _resolveComponent("VueDatepicker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        type: "button",
        class: "button-p text-center whitespace-nowrap w-fit md:hidden",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.submitReport && _ctx.submitReport(...args))),
        disabled: _ctx.isEdit
      }, [
        _hoisted_3,
        _createTextVNode(" Hoàn thành báo cáo ")
      ], 8, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("button", {
          type: "button",
          class: "button-p text-center whitespace-nowrap w-fit md-down:hidden",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submitReport && _ctx.submitReport(...args))),
          disabled: _ctx.isEdit
        }, [
          _hoisted_9,
          _createTextVNode(" Hoàn thành báo cáo ")
        ], 8, _hoisted_8)
      ])
    ]),
    _createElementVNode("div", null, [
      (_ctx.isEdit)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$filters.terminology('plan')) + " " + _toDisplayString(_ctx.reportOrder), 1),
              _hoisted_14
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _hoisted_18,
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _withDirectives(_createElementVNode("input", {
                      value: 1,
                      name: "notification-method",
                      type: "radio",
                      class: "h-4 w-4 text-yellow-600 border-neutral-400 border-2 focus:ring-yellow-600",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.applyNow) = $event))
                    }, null, 512), [
                      [_vModelRadio, _ctx.applyNow]
                    ]),
                    _createElementVNode("label", {
                      class: "pl-3 block text-sm font-medium text-neutral-800",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.applyNow = 1))
                    }, [
                      _createTextVNode(" Áp dụng ngay (Trở thành "),
                      _hoisted_21,
                      _createTextVNode(", có thể dạy các mục tiêu trong kế hoạch) ")
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _withDirectives(_createElementVNode("input", {
                      value: 2,
                      name: "notification-method",
                      type: "radio",
                      class: "h-4 w-4 text-yellow-600 border-neutral-400 border-2 focus:ring-yellow-600",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.applyNow) = $event))
                    }, null, 512), [
                      [_vModelRadio, _ctx.applyNow]
                    ]),
                    _createElementVNode("label", {
                      class: "pl-3 block text-sm font-medium text-neutral-800",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.applyNow = 2))
                    }, [
                      _createTextVNode(" Áp dụng sau (Trở thành "),
                      _hoisted_23,
                      _createTextVNode(", tới ngày áp dụng, Kế hoạch dự kiến sẽ trở thành kế hoạch hiện tại) ")
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  (_ctx.applyNow === 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dateNow) = $event)),
                            type: "text",
                            placeholder: "Chọn ngày áp dụng",
                            readonly: ""
                          }, null, 512), [
                            [_vModelText, _ctx.dateNow]
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.applyNow === 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _createVNode(_component_VueDatepicker, {
                            modelValue: _ctx.applyDate,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.applyDate) = $event)),
                            enableTimePicker: false,
                            class: "input-date w-full",
                            placeholder: "Chọn ngày áp dụng",
                            format: "dd/MM/yyyy",
                            autoApply: ""
                          }, {
                            "input-icon": _withCtx(() => [
                              _createVNode(_component_DaIcon, {
                                name: "das--lock",
                                class: "h-4 w-4 text-neutral-400"
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("button", {
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.done && _ctx.done(...args))),
                type: "button",
                class: "button-p text-center whitespace-nowrap w-fit",
                disabled: _ctx.applyNow !== 1 && !(_ctx.applyNow == 2 && _ctx.applyDate)
              }, " Xác nhận ", 8, _hoisted_30)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("div", null, [
                (_openBlock(), _createElementBlock("svg", {
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isEdit = true)),
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                  class: "cursor-pointer text-neutral-400 hover:text-neutral-600"
                }, _hoisted_35))
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.$filters.terminology('plan')), 1),
                _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.$filters.terminology('plan')) + " " + _toDisplayString(_ctx.reportOrder), 1)
              ]),
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                (_ctx.applyNow === 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(_ctx.dateNow), 1))
                  : _createCommentVNode("", true),
                (_ctx.applyNow === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(_ctx.applyDateText), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ])),
      _hoisted_44,
      _createElementVNode("div", _hoisted_45, [
        _createElementVNode("div", _hoisted_46, [
          _hoisted_47,
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _hoisted_51,
                _createTextVNode(" " + _toDisplayString(_ctx.skills_count), 1)
              ]),
              _hoisted_52
            ]),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _hoisted_55,
                _createTextVNode(" " + _toDisplayString(_ctx.goals_count), 1)
              ]),
              _hoisted_56
            ]),
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("div", _hoisted_58, [
                _hoisted_59,
                _createTextVNode(" " + _toDisplayString(_ctx.continued_goals_count), 1)
              ]),
              _hoisted_60
            ])
          ])
        ]),
        (_ctx.goals && _ctx.goals.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.goals, (goal, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "mb-10",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_62, _toDisplayString(index + 1) + ". " + _toDisplayString(goal.skill.name) + " (" + _toDisplayString(goal.goals.length) + ") ", 1),
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("div", _hoisted_65, [
                          _createElementVNode("table", _hoisted_66, [
                            _hoisted_67,
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(goal.goals, (g, i) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: g.id,
                                  class: _normalizeClass([
													i % 2 === 0
														? 'bg-white'
														: 'bg-neutral-50'
												, "text-neutral-700"])
                                }, [
                                  _createElementVNode("td", _hoisted_68, [
                                    _createElementVNode("div", _hoisted_69, _toDisplayString(i + 1), 1)
                                  ]),
                                  _createElementVNode("td", _hoisted_70, [
                                    _createElementVNode("div", {
                                      innerHTML: 
															g.goal_name ||
															g.name
														
                                    }, null, 8, _hoisted_71),
                                    (
															(g?.assistance_levels &&
																_ctx.org.enable_goal_assistance_level) ||
															g?.display_source ||
															g?.age
														)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                          (g?.display_source)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_73, _toDisplayString(g?.display_source), 1))
                                            : _createCommentVNode("", true),
                                          (
																g?.assistance_levels &&
																_ctx.org.enable_goal_assistance_level
															)
                                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(g?.assistance_levels, (ass) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  key: ass,
                                                  class: "flex gap-2"
                                                }, [
                                                  _createElementVNode("div", _hoisted_74, _toDisplayString(ass), 1)
                                                ]))
                                              }), 128))
                                            : _createCommentVNode("", true),
                                          (g?.age)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_75, _toDisplayString(g?.age), 1))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (
															g.parent
																?.sub_goal_count >
															0
														)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                          _hoisted_77,
                                          _createElementVNode("div", null, [
                                            _createElementVNode("div", _hoisted_78, _toDisplayString(g.parent
																		?.name), 1),
                                            _createElementVNode("div", _hoisted_79, _toDisplayString(g.parent
																		?.sub_goal_count) + " MỤC TIÊU ", 1)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ], 2))
                              }), 128))
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_80, _hoisted_83))
      ])
    ])
  ], 64))
}